
import { Component, Vue } from 'vue-property-decorator';
import { CommonStore, FarmStore, SensorStore } from '@/store/modules';
import SvgIcon from '@/components/SvgIcon.vue';
import { SensorLocation } from '@/store/models/sensor';
import helpers from '@/utils/helpers';

import { colors } from 'quasar';
const { getPaletteColor } = colors;

@Component({
  components: {
    SvgIcon
  }
})
export default class ModelerAlbums extends Vue {
  farmId = 0;
  loading = false;
  deleteDialog = false;
  sensorLocation: SensorLocation = {} as SensorLocation;

  get farm() {
    return JSON.parse(JSON.stringify(FarmStore.AddEditFarm));
  }
  get sensorLocations() {
    return JSON.parse(JSON.stringify(SensorStore.SensorLocations));
  }
  get currentFarm() {
    return CommonStore.SelectedFarmBlock;
  }

  tableColumn = [
    {
      name: 'id',
      label: 'Id',
      field: (row: SensorLocation) => row.id,
      sortable: true,
      align: 'left',
      style: 'width: 10px',
      headerStyle: 'width: 10px;'
    },
    {
      name: 'location_name',
      label: 'Location Name',
      field: (row: SensorLocation) => row.locationName,
      sortable: true,
      align: 'left'
    },
    {
      name: 'plus_code',
      label: 'Plus Code',
      field: (row: SensorLocation) => row.plusCode,
      sortable: true,
      align: 'left'
    },
    {
      name: 'sensor_id',
      label: 'Sensor Id',
      field: (row: SensorLocation) => row.sensorId,
      sortable: true,
      align: 'left'
    },
    {
      name: 'nearest_bom_station',
      label: 'Nearest BoM Station',
      field: (row: SensorLocation) => row.nearestBomStation,
      sortable: true,
      align: 'left'
    },
    {
      name: 'actions',
      label: 'Actions',
      align: 'left',
      style: 'width: 260px;'
    }
  ];
  initialPagination: {
    sortBy: string;
    descending: boolean;
    page: number;
    rowsPerPage: number;
  } = {
    sortBy: 'id',
    descending: false,
    page: 1,
    rowsPerPage: 10
  };

  getPaletteColor(colorName: string) {
    return getPaletteColor(colorName);
  }

  editSensorLocation(sensorLocation: SensorLocation) {
    this.sensorLocation = sensorLocation;
    SensorStore.setAddEditSensorLocation(sensorLocation);
  }

  async onDelete(sensorLocationId: number) {
    this.deleteDialog = false;
    if (sensorLocationId != 0) {
      SensorStore.deleteSensorLocation(sensorLocationId);

      SensorStore.setAddEditSensorLocation({} as SensorLocation);
    }
  }

  deleteSensorLocation(sensorLocation: SensorLocation) {
    this.sensorLocation = sensorLocation;
    this.deleteDialog = true;
  }

  async created() {
    this.loading = true;
    await helpers.fetchingDefaultFarm();
    SensorStore.getSensorLocations({
      farm: this.currentFarm.farmId,
      block: this.currentFarm.blockId
    });

    if (this.$route.params.farmId) {
      this.farmId = Number(this.$route.params.farmId);
      await FarmStore.getFarmById(this.farmId);
    }
    this.loading = false;
  }
}
